<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

const navItems = [
  { name: 'routes', label: 'Routes', icon: 'routes' },
  { name: 'log', label: 'Log', icon: 'log' },
  { name: 'profile', label: 'Profile', icon: 'profile' }
]

function isActive(name: string): boolean {
  return route.name === name || (name === 'routes' && route.name === 'route-detail')
}

function navigateTo(name: string): void {
  router.push({ name })
}
</script>

<template>
  <nav class="app-navigation">
    <button
      v-for="item in navItems"
      :key="item.name"
      class="nav-item"
      :class="{ active: isActive(item.name) }"
      @click="navigateTo(item.name)"
    >
      <div class="nav-icon">
        <!-- Routes icon -->
        <svg v-if="item.icon === 'routes'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 12h4l3-9 4 18 3-9h4" />
        </svg>
        <!-- Log icon -->
        <svg v-if="item.icon === 'log'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
          <path d="M12 8l1 4-3 1" />
        </svg>
        <!-- Profile icon -->
        <svg v-if="item.icon === 'profile'" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </div>
      <span class="nav-label">{{ item.label }}</span>
    </button>
  </nav>
</template>

<style scoped>
.app-navigation {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--color-background);
  border-top: 1px solid var(--color-border);
  padding: var(--spacing-sm) 0;
  z-index: 100;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-xs);
  padding: var(--spacing-sm) var(--spacing-lg);
  background: none;
  border: none;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: color 0.2s;
}

.nav-item:hover,
.nav-item.active {
  color: var(--color-text);
}

.nav-item.active .nav-icon {
  color: var(--color-primary);
}

.nav-icon {
  width: 24px;
  height: 24px;
}

.nav-label {
  font-size: 0.75rem;
  font-weight: 500;
}
</style>
